export default __webpack_public_path__ + "static/media/03.e318a90e.jpg";